// extracted by mini-css-extract-plugin
module.exports = {"play":"PlayButton_play__9VaR4","hidden":"PlayButton_hidden__wPqrj"};